import { createBlock } from 'factories/block';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import Correct_default from 'assets/CC_Scorable Images_Correct.png';
// Correct_loop.gif'; // Correct_default.svg';
import Incorrect_default from 'assets/CC_Scorable Images_Incorrect.png';
//Incorrect_loop.gif'; // Incorrect_default.svg';
import Attempt_default from 'assets/CC_Scorable Images_Number of Atempts.png';
//Attempt.svg'; // Incorrect_default.svg';
import { createMediaBlock } from './media';

export const createFeedbackBlock = ({ ...props }) => {
  const label = props.label || 'Continue';

  return createBlock(
    'Feedback',
    [
      createBlock(
        'Correct',
        [
          // createBlock('Image', [], {
          //   props: { src: Correct_default },
          //   meta: {
          //     subType: 'Correct_Feedback',
          //   },
          // }),
          createMediaBlock({
            src: Correct_default,
            child: 1,
            // fit: 'cover',
            useBackgroundControls: false,
          }),
          createBlock('Text'),
          createContinueBtn({
            unlocked: true,
            removeable: false,
          }),
        ],
        {
          props: { type: 'Correct_Feedback' },
          meta: {
            subType: 'Correct_Feedback',
          },
        }
      ),
      createBlock(
        'Incorrect',
        [
          // createBlock('Image', [], {
          //   props: { type: 'Incorrect_Feedback', src: Incorrect_default },
          //   meta: {
          //     subType: 'Incorrect_Feedback',
          //   },
          // }),
          createMediaBlock({
            src: Incorrect_default,
            child: 1,
            // fit: 'cover',
            useBackgroundControls: false,
          }),
          createBlock('Text'),
          createContinueBtn({
            unlocked: true,
            removeable: false,
          }),
        ],
        {
          props: { type: 'Incorrect_Feedback' },
          meta: {
            subType: 'Incorrect_Feedback',
          },
        }
      ),
      createBlock(
        'Attempt',
        [
          // createBlock('Image', [], {
          //   props: {
          //     type: 'Attempt_Feedback',
          //     src: Attempt_default,
          //   },
          //   meta: {
          //     subType: 'Attempt_Feedback',
          //   },
          // }),
          createMediaBlock({
            src: Attempt_default,
            child: 1,
            // fit: 'cover',
            useBackgroundControls: false,
          }),

          createBlock('Text'),
          createEditableBtn({
            type: 'Feedback_Button_Attempt',
            label: 'Try again',
          }),
        ],
        {
          props: { type: 'Attempt_Feedback' },
          meta: {
            subType: 'Attempt_Feedback',
          },
        }
      ),
      createEditableBtn({ type: 'Feedback_Button', label }),
    ],
    {
      props: {
        type: 'Feedback',
        name: props.name || '',
        style: props.style || {},
      },
      meta: {
        subType: 'Feedback',
      },
    }
  );
};
